module.exports = __webpack_public_path__ + "img/img1.d7a2066c.png";